import { render } from "./column.vue?vue&type=template&id=c75f811a&scoped=true&ts=true"
import script from "./column.vue?vue&type=script&lang=ts"
export * from "./column.vue?vue&type=script&lang=ts"

import "./column.vue?vue&type=style&index=0&id=c75f811a&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c75f811a"]])

export default __exports__